<template>
    <div>
        <div class="contentBox" @click="changRoute" style="pointer-events: auto"  >
          <div :class="{btnBox:true, leftBtn:true, noBtnBox: !leftBtnShow}" v-show='true' @click="page--" @mouseover="overBtnURL('left')" @mouseout="outBtnURL('left')"><img :src="btnLeftURL" alt=""></div>
          <div class="listBox clearfix">
              <div class="list" v-for="productInfo in productInfos" :key="productInfo.id" :id="productInfo.id" >
                  <img class=" scaleactive" :src="$baseURL + productInfo.imgUrl" alt="">
                  <p class="info">{{productInfo.name}}<br/>{{productInfo.company}}</p>
              </div>
          </div>
          <div :class="{btnBox:true, rightBtn:true, noBtnBox: !rightBtnShow}" v-show='true' @click="page++" @mouseover="overBtnURL('right')" @mouseout="outBtnURL('right')"><img :src="btnRightURL" alt=""></div>
        </div>
    </div>   
     
</template>
<script>
export default {
  name: 'Home',  
  props:{
    title: String
  },
  data(){
    return {
       
       btnLeftURL: this.$baseURL + "image/btn.png",
       btnRightURL: this.$baseURL + "image/btn.png",
       productInfos: [],
       pageInfos:[],
       time: '',
       page: 0,
       leftBtnShow: false,
       rightBtnShow: true,
    }
  },
  watch: {
    page: function (value){
      this.rightBtnShow = true;
      console.log(this.pageInfos);
      if(this.page > 0){
        this.leftBtnShow = true;
      }
      if(this.page < 1){
        this.leftBtnShow = false;
      }
      if(this.pageInfos && this.pageInfos.length>9){
        let start = 0 + (value * 9);
        let end = 9 + (value * 9);
        let length = this.pageInfos.length;
        if(length < end){
          end = length;
          this.rightBtnShow = false;
        }
        
        this.productInfos = this.pageInfos.slice(start, end);
      }
      
      return value;
    }
  },
  
  created(){
   
    this.$axios.get(this.$baseURL + 'data/productData.json')
    .then(res => {

        this.pageInfos = res.data;
        let start = 0 + (this.page * 9);
        let end = 9 + (this.page * 9);
        this.productInfos = this.pageInfos.slice(start, end);
        
        
    })
  },
  methods:{
    overBtnURL(value){
      if(value === 'left')
        this.btnLeftURL = this.$baseURL + "image/btnover.png";
      else
        this.btnRightURL = this.$baseURL + "image/btnover.png";
    },
    outBtnURL(value){
      if(value === 'left')
        this.btnLeftURL = this.$baseURL + "image/btn.png";
      else
        this.btnRightURL = this.$baseURL + "image/btn.png";
    },
    changRoute(e){
        if(!e.target.id){
            if(!e.target.parentElement.id){
                return
            }else{
                this.$router.push({ name: 'product', params: { id: e.target.parentElement.id }})
                
            }
        }else{
            this.$router.push({ name: 'product', params: { id: e.target.id }})
            
        }
    }
  }
}
</script>
<style scoped>
  
</style>